import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { NUMBERS_ONLY_REGEX } from 'src/utilities/regexPatterns';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface ZipCodeControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function ZipCodeControl({
  name,
  id,
  rules,
}: ZipCodeControlProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      label={addAsterisk('Zip Code', rules)}
      placeholder="e.g. 10018"
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      rules={{
        minLength: {
          value: 5,
          message: 'Invalid Zip Code',
        },
        maxLength: {
          value: 10,
          message: 'Invalid Zip Code',
        },
        pattern: {
          value: NUMBERS_ONLY_REGEX,
          message: 'Invalid Zip Code',
        },
        ...rules,
      }}
    />
  );
}
